import { useDealerConfig } from "@hooks/useDealerConfig";
import { DEALER_CONTEXT_TYPE, useDealerContextStore } from "@lyteflo/utils";

export const useDealerFlagTarget = () => {
  const { context } = useDealerContextStore();
  const contextConfigId =
    context.type === DEALER_CONTEXT_TYPE.DEALERSHIP ? context.id : null;
  const { data, isLoading } = useDealerConfig(contextConfigId);
  // A failed revalidation keeps the last config in `data`.
  const config = !isLoading && data ? data : null;
  const isSettled = !contextConfigId || !isLoading;
  return { config, isSettled };
};
